import React from "react";
import PropTypes from "prop-types";
import GenericContactTable from "../../../../../../../components/ContactsTable/GenericContactsTable";
import { contactRoles } from "../../../config/customerConfig";
import useCustomerContacts from "../../../hooks/useCustomerContact";
import { useSelector, useDispatch } from "react-redux";
import {
  selectedSelectedCustomerContact,
  setSelectedCustomerContact,
  clearSelectedCustomerContact,
} from "../../../../../../../redux/customers/selectedCustomerContactSlice";

const CustomerContactTable = ({ isEditMode, onAddNew, onRowClick }) => {
  const selected = useSelector((state) => state.selectedCustomer);
  const customerId = selected?.customerID;
  const selectedContact = useSelector(selectedSelectedCustomerContact);
  const dispatch = useDispatch();

  const onSelectContact = (contact) => {
    if (selectedContact && selectedContact.contactID === contact.contactID) {
      dispatch(clearSelectedCustomerContact());
    } else {
      dispatch(setSelectedCustomerContact(contact));
    }
  };

  return (
    <GenericContactTable
      isEditMode={isEditMode}
      onAddNew={onAddNew}
      onRowClick={onRowClick}
      onSelectContact={onSelectContact}
      rolesConfig={contactRoles}
      useContactsHook={useCustomerContacts}
      entityId={customerId}
      selectedContact={selectedContact}
    />
  );
};

CustomerContactTable.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  onAddNew: PropTypes.func,
  onRowClick: PropTypes.func,
};

export default CustomerContactTable;
